import React from 'react';
import { Trophy, TrendingUp, DollarSign, Clock, Award } from 'lucide-react';
import { BRAND_COLORS, NEUTRAL_COLORS, SYSTEM_COLORS } from '../../../constants/brandPalette';

const CompetitionMetrics = ({ metrics }) => {
  if (!metrics) return null;

  const cards = [
    {
      label: 'Total Applications',
      value: metrics.totalApplications,
      icon: Award,
      iconBg: SYSTEM_COLORS.infoTint,
      iconColor: SYSTEM_COLORS.info,
    },
    {
      label: 'Success Rate',
      value: `${Number(metrics.successRate ?? 0).toFixed(1)}%`,
      icon: TrendingUp,
      iconBg: SYSTEM_COLORS.successTint,
      iconColor: SYSTEM_COLORS.success,
    },
    {
      label: 'Total Funding',
      value: `$${Number(metrics.totalFundingReceived ?? 0).toLocaleString()}`,
      icon: DollarSign,
      iconBg: '#ede9fe',
      iconColor: '#7c3aed',
    },
    {
      label: 'Active Competitions',
      value: metrics.activeCompetitions,
      icon: Trophy,
      iconBg: SYSTEM_COLORS.warningTint,
      iconColor: SYSTEM_COLORS.warning,
    },
    {
      label: 'Upcoming Deadlines',
      value: metrics.upcomingDeadlines,
      icon: Clock,
      iconBg: SYSTEM_COLORS.dangerTint,
      iconColor: SYSTEM_COLORS.danger,
    },
  ];

  return (
    <div
      className="rounded-2xl border p-5 sm:p-6"
      style={{
        backgroundColor: SYSTEM_COLORS.shellSurface,
        borderColor: SYSTEM_COLORS.borderSoft,
        boxShadow: SYSTEM_COLORS.shadowSoft,
      }}
    >
      <p
        className="text-xs font-semibold uppercase tracking-[0.18em] mb-4"
        style={{ color: BRAND_COLORS.primary }}
      >
        Analytics
      </p>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 sm:gap-4">
        {cards.map((card) => {
          const Icon = card.icon;
          return (
            <div
              key={card.label}
              className="flex items-center gap-3 p-3 sm:p-4 rounded-xl border"
              style={{
                borderColor: SYSTEM_COLORS.borderSoft,
                backgroundColor: SYSTEM_COLORS.surfaceSubtle,
              }}
            >
              <div
                className="flex-shrink-0 flex items-center justify-center w-10 h-10 rounded-xl"
                style={{ backgroundColor: card.iconBg }}
              >
                <Icon className="w-5 h-5" style={{ color: card.iconColor }} />
              </div>
              <div className="min-w-0">
                <p className="text-xs leading-4" style={{ color: SYSTEM_COLORS.textMuted }}>
                  {card.label}
                </p>
                <p className="mt-0.5 text-lg font-bold leading-6 truncate" style={{ color: NEUTRAL_COLORS.black }}>
                  {card.value}
                </p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default CompetitionMetrics;
